module.exports = __webpack_public_path__ + "img/arrow-right.c2c947c1.svg";